import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { retrievePreferences } from "../../../redux/slice/preferences.slice";
import { RootState, useAppDispatch } from "../../../redux/store";

import { Helmet } from "react-helmet-async";
import LoadingComp from "../../../components/re-usable/loading/loading";
import EmailInputComponent from "./email-input.component";
import NewsLetterSubFooterComponent from "./news-letter-sub-footer.component";
import NewsLetterSubComponent from "./news-letter-sub.component";
import PageTitleComponent from "./page-title.component";
import HeaderUnSubscribeAllComponent from "./unsubscribe-all-header.component";
import WelcomeComponent from "./welcome.component";

const PreferencesPageComponent = () => {
  const { checkLogin } = useSelector((state: RootState) => state.loggedIn);
  const Preferences = useSelector((state: RootState) => state.preferences);
  const PreferencesData = Preferences.data.result;

  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const [description, setDescription] = useState("");

  const [isLoggedIn, setIsLoggedIn] = useState(false); //checkLogin.isLoggedIn);
  const [isMember, setIsMember] = useState(false);
  const [isNewEmail, setIsNewEmail] = useState(false);
  const [isUnsubscribeCalled, setIsUnsubscribeCalled] = useState(false);

  const dispatch = useAppDispatch();

  const calledUnsubscribe = () => {
    setIsUnsubscribeCalled(!isUnsubscribeCalled);
  }

  useEffect(() => {
    dispatch(retrievePreferences());
  }, []);

  useEffect(() => {
    if (RapsEuropeData[0]) {
      let rapsResult = RapsEuropeData[0].result && RapsEuropeData[0].result[0];
      if (rapsResult) {
        setDescription(rapsResult.description);
      }
    }
  }, [RapsEuropeData]);

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <PageTitleComponent />
      <div id="preferences-root">
        <div className="container">
          <div className="panel">
            <div className="panel-body">
              <WelcomeComponent isLoggedIn={isLoggedIn} isMember={true} isNewEmail={isNewEmail} />
              {isLoggedIn && PreferencesData?.length > 0 && <HeaderUnSubscribeAllComponent calledUnsubscribe={calledUnsubscribe} />}
              <EmailInputComponent isLoggedIn={isLoggedIn} isNewEmail={isNewEmail} setFormValue={setIsLoggedIn} setIsNewEmail={setIsNewEmail} calledUnsubscribe={calledUnsubscribe} />
            </div>
            <div id="subwindow" className="modal react-modal"></div>
          </div>
        </div>
        {isLoggedIn && PreferencesData?.length > 0 ? (
          <div className="row">
            <NewsLetterSubComponent preferenceData={PreferencesData} isUnsubscribeCalled={isUnsubscribeCalled} calledUnsubscribe={calledUnsubscribe} />
          </div>
        ) : (
          <div className="row">
            <div className="col-md-12">
              <p>&nbsp;</p>
              <p>&nbsp;</p>
            </div>
          </div>
        )}
      </div>
      {description !== "" && <div className="col-md-12 profile" dangerouslySetInnerHTML={{ __html: description }}></div>}
    </>
  );
};

export default PreferencesPageComponent;
